// video.js プレイヤーの設定生成関数
//
// 用途別にプレイヤーオプションを返す。グローバルオプション（videojs.options.*）は
// 使用せず、すべてプレイヤーオプションとして統合する。

/**
 * 全用途共通のベース設定を返す（内部関数）。
 *
 * 以下のグローバルオプションをプレイヤーオプションに統合:
 * - videojs.options.vhs.overrideNative = true
 * - videojs.options.html5.nativeAudioTracks = false
 * - videojs.options.html5.nativeVideoTracks = false
 */
function createBaseSettings() {
  return {
    fluid: true,
    html5: {
      nativeAudioTracks: false,
      nativeVideoTracks: false,
      vhs: {
        overrideNative: true,
      },
    },
    controlBar: {
      volumePanel: { inline: false },
    },
  };
}

/**
 * VOD（オンデマンド）用の設定を返す。
 *
 * controlBar は children array 形式。
 *
 * @param {Object} [options={}]
 * @param {boolean} [options.playsinline] - iOS Safari でインライン再生する場合に true
 * @param {string}  [options.poster]      - ポスター画像の URL
 */
export function createVodSettings({ playsinline, poster } = {}) {
  const base = createBaseSettings();
  return {
    ...base,
    textTrackSettings: false,
    playbackRates: [0.75, 1, 1.25, 1.5, 2],
    controlBar: {
      ...base.controlBar,
      children: [
        'playToggle',
        'volumePanel',
        'progressControl',
        'placeholderButton',
        'currentTimeDisplay',
        'timeDivider',
        'durationDisplay',
        'qualitySelector',
        'playbackRateMenuButton',
        'captionsButton',
        'fullscreenToggle',
      ],
    },
    ...(playsinline != null && { playsinline }),
    ...(poster != null && { poster }),
  };
}

/**
 * ライブ配信用の設定を返す。
 *
 * controlBar は property 形式。
 *
 * 以下のライブ固有グローバルオプションをプレイヤーオプションに統合:
 * - videojs.options.html5.nativeTextTracks = false
 * - videojs.options.vhs.enableLowInitialPlaylist = true
 * - videojs.options.vhs.allowSeeksWithinUnsafeLiveWindow = true
 */
export function createLiveSettings() {
  const base = createBaseSettings();
  return {
    ...base,
    html5: {
      ...base.html5,
      nativeTextTracks: false,
      vhs: {
        ...base.html5.vhs,
        enableLowInitialPlaylist: true,
        allowSeeksWithinUnsafeLiveWindow: true,
      },
    },
    controlBar: {
      ...base.controlBar,
      playToggle: true,
      liveDisplay: true,
      progressControl: true,
      qualitySelector: true,
      fullscreenToggle: true,
      subtitlesButton: true,
    },
  };
}
